<template>
  <vue-good-table
    style="width: 100%;"
    :rows="getOrders"
    :columns="columns"
    :pagination-options="paginationOptions"
    :search-options="{
      enabled: true,
      trigger: 'enter',
      placeholder: 'Procurar',
      skipDiacritics: true,
    }"
    styleClass="vgt-table condensed">
    <div slot="emptystate" class="text-center">
      Nenhum resultado encontrado
    </div>

    <template slot="column-filter" slot-scope="{ column, updateFilters }">
      <v-select
        appendToBody
        v-if="column.filterOptions && column.filterOptions.enabled"
        :options="column.filterOptions.items"
        :placeholder="column.filterOptions.placeholder || 'Selecione'"
        @input="(valuesArray) => updateFilters(column, valuesArray)">
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            Nenhuma resultado encontrado para <em>{{ search }}</em>.
          </template>
          <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
        </template>
      </v-select>
    </template>

    <template slot="table-row" slot-scope="order">
      <span v-if="order.column.field == 'status'">
        <div class="truncate">
          <div
            class="ml-1 h-3 w-3 rounded-full mr-2 border-2 border-solid inline-block"
            :class="`border-${order.row.cor} bg-${order.row.cor}`" />
          <span class="font-medium">{{ order.row.status }}</span>
        </div>
      </span>
      <span class="font-medium" v-else-if="order.column.field == 'jsonProdutos'">
        <vs-dropdown class="cursor-pointer" vs-trigger-click>
          <a class="flex items-center" style="font-weight: 500; font-size: 1rem" href="#">
            {{ productsLength(order.row.jsonProdutos) }} itens
            <i class="material-icons"> expand_more </i>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-item :divider="index != 0" v-for="(product, index) in parseProducts(order.row.jsonProdutos)" v-bind:key="product.codigo">
              Código: {{ product.codigo }}
              <br>
              Quantidade: {{ product.quantidade }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </span>
      <span class="font-medium" v-else>
        {{ order.formattedRow[order.column.field] }}
      </span>
    </template>
  </vue-good-table>
</template>
<script>
import helpers from "@/helpers";
export default {
  components: {},
  data() {
    return {
      orders: [],
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    }
  },
  computed: {
    getOrders() {
      const orders = this.$store.state.orders
      return orders
    },
  },
  methods: {
    productsLength(products) {
      products = JSON.parse(products)
      return products.length
    },
    parseProducts(products) {
      return JSON.parse(products)
    },
    getAllLabelFilters() {
      let filters = {}
      filters.cliente = this.$store.state.orders.map(item => item.cliente.trim())

      for (let filter of Object.keys(filters)) {
        let index = this.columns.findIndex(item => {
          return item.field === filter
        })
        this.setDropdownFilter(index, filters[filter])
      }
    },
    setDropdownFilter(index, label) {
      label.sort((a, b) => a.localeCompare(b))
      label = [...new Set(label)]
      this.$set(this.columns[index], 'filterOptions', {
        enabled: true,
        items: label,
        customFilter: true,
        formatValue: this.formatFilterValue
      })
    },
    sortPrecoTotal(preco, precoAnterior) {
      preco = +preco
      precoAnterior = +precoAnterior
      return preco < precoAnterior ? -1 : preco > precoAnterior ? 1 : 0
    },
    sortJsonProdutos(num, numAnterior) {
      num = this.productsLength(num)
      numAnterior = this.productsLength(numAnterior)
      return num < numAnterior ? -1 : num > numAnterior ? 1 : 0
    },
    mountTable() {
      this.columns = [{
          label: 'ID',
          field: 'IdWebMaisPed'
        },
        {
          label: 'Cliente',
          field: 'cliente'
        },
        {
          label: 'Empresa',
          field: 'nomeCurto',
          filterOptions: {
            enabled: true,
            items: ['REGNAPARTS', 'REVESTEBEM'],
          }
        },
        {
          label: 'Representante',
          field: 'representante',
          filterOptions: {
            enabled: true,
            items: ['RAPHAEL', 'GILMAR'],
          }
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: {
            enabled: true,
            items: [
              'Aprovação Comercial',
              'Aprovação Financeira',
              'Faturamento',
              'Expedição',
              'Concluído'
            ],
          }
        },

        {
          label: 'Emissão',
          field: 'dataEmissao',
          formatFn: this.helpers.dateHelper.formatDateToPTBR
        },

        {
          label: 'Produtos',
          field: 'jsonProdutos',
          sortFn: this.sortJsonProdutos
        },

        {
          label: 'Total',
          field: 'precoTotal',
          formatFn: this.helpers.moneyHelper.formatNumberToCurrency,
          sortFn: this.sortPrecoTotal,
        },
      ]
    }
  },
  async created() {
    this.helpers = helpers
    let payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchOrdersItems", payload)
    this.mountTable()
    this.getAllLabelFilters()
  },
}

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
